module.exports = __webpack_public_path__ + "fonts/icons/cm-icons.ttf?74f9afc2899c7eb0f4d00029bfd796d9";